// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import DraftRefreshController from "./draft_refresh_controller"
application.register("draft-refresh", DraftRefreshController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import ProductDemoController from "./product_demo_controller"
application.register("product-demo", ProductDemoController)
